/**
 * useCalendar -- Calendar events store (Zustand).
 */
import { create } from 'zustand'
import { getCalendarEvents } from '@/lib/api'
import type { CalendarEvent } from '@/lib/types'

interface CalendarState {
  events: CalendarEvent[]
  loading: boolean
  error: string | null

  fetchEvents: (days?: number) => Promise<void>
}

export const useCalendar = create<CalendarState>()((set) => ({
  events: [],
  loading: false,
  error: null,

  fetchEvents: async (days = 14) => {
    set({ loading: true, error: null })
    try {
      const events = await getCalendarEvents(days)
      set({ events: events ?? [], loading: false })
    } catch (e: unknown) {
      // Keep the real failure message — the page renders it next to a Retry button
      const detail = (e as { response?: { data?: { detail?: string } } })?.response?.data?.detail
      const msg = detail ?? (e instanceof Error ? e.message : String(e))
      set({ error: msg || 'Failed to load calendar events', loading: false })
    }
  },
}))
